import { StyledModal } from '@app/components/modal/Modal';
import useNumberActions from '@app/hooks/numbers/useNumberActions';
import type { AINumber } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type NumberDeleteModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
};

export const NumberDeleteModal = ({ title, data, ...props }: NumberDeleteModalProps) => {
    const { deleteNumber } = useNumberActions();

    const isUnassigned = !data?.location_id;
    const modalTitle = title ?? (isUnassigned ? 'Delete AI Agent Number' : 'Unlink AI Agent');
    const confirmMessage = isUnassigned
        ? 'Are you sure you want to remove this AI Agent Number?'
        : 'Before you can remove this AI Agent Number, you must unlink any assigned agents. Are you sure you want to unlink the AI Agent from this number?';

    return (
        <StyledModal
            title={modalTitle}
            okText={isUnassigned ? 'Delete' : 'Unlink'}
            {...props}
            confirmLoading={deleteNumber?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteNumber.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>{confirmMessage}</p>
        </StyledModal>
    );
};
